import {fork} from 'redux-saga/effects';
import getPartnersMessagesFlow from './sagas/getPartnersMessagesFlow';

/**
 * Load VP messages
 */
export const loadPartnersMessages = function* loadPartnersMessages() {
    yield fork(getPartnersMessagesFlow);
};
